var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about-con"},[_c('mobile-header',{attrs:{"active-route":_vm.activeRoute},on:{"active-up":_vm.beforeRoute}}),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('mobile-footer',{attrs:{"linkVisible":_vm.linkVisible,"applyFooterStyle":_vm.applyFooterStyle}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a754caee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page-components-mobile/index.vue
// module id = null
// module chunks = 